import React from 'react';

import styles from './DownArrowHint.scss';
import ArrowIcon from './arrow.svg';

class DownArrowHint extends React.Component {
  render() {
    const { clickHandler, style } = this.props;
    return (
      <div
        className={`DownArrowHint`}
        style={style}
        onClick={e => clickHandler(e)}
      >
        <ArrowIcon className="DownArrowHint__indicator" />
        <ArrowIcon className="DownArrowHint__indicator" />
      </div>
    );
  }
}

export default DownArrowHint;
